var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsBgSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 396,
    viewBox: "0 0 375 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1029_3316)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.15,
    cy: 207.226,
    rx: 192.591,
    ry: 49.1014,
    transform: "rotate(8.54182 174.15 207.226)",
    fill: "#31D054"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-88.3488 114.036C-36.3183 139.926 312.729 298.042 506 134.878V396C462.789 341.612 350.128 247.605 171.396 211.265C5.98705 177.633 -172.501 315.959 -186.163 345.32V350.147C-187.294 349.343 -187.263 347.685 -186.163 345.32V0C-171.759 27.7684 -140.379 88.1457 -88.3488 114.036Z",
    fill: "url(#paint0_diamond_1029_3316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1029_3316",
    x: -116.447,
    y: 50.8604,
    width: 581.195,
    height: 312.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1029_3316"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_1029_3316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-117.453 158.709) rotate(10.0919) scale(703.577 1233.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.031676,
    stopColor: "#01061B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261549,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729914,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01061B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsBgSmall);
export default __webpack_public_path__ + "static/media/about_us_bg_small.8cd51a18a88394769e976176fd9381f0.svg";
export { ForwardRef as ReactComponent };